import { CountryTypeDto, ExperienceCompanyTypeDto } from '@/api/generated';

export type ExperienceCompaniesTranslation = {
  actions: string;
  addButton: string;
  allCountries: string;
  allTypes: string;
  columns: {
    actions: string;
    country: string;
    name: string;
    type: string;
  };
  countries: Record<CountryTypeDto, string>;
  deleteConfirmation: string;
  dialog: {
    buttons: {
      cancel: string;
      create: string;
      save: string;
    };
    createTitle: string;
    editTitle: string;
    fields: {
      country: string;
      name: string;
      type: string;
    };
    validation: {
      nameExists: string;
      nameRequired: string;
    };
  };
  filterByCountry: string;
  filterByType: string;
  noResults: string;
  searchPlaceholder: string;
  types: Record<ExperienceCompanyTypeDto, string>;
};

export const experienceCompaniesTranslation: ExperienceCompaniesTranslation = {
  actions: 'Actions',
  addButton: 'Add Company',
  allCountries: 'All countries',
  allTypes: 'All types',
  columns: {
    actions: 'Actions',
    country: 'Country',
    name: 'Name',
    type: 'Type',
  },
  countries: {
    [CountryTypeDto.Be]: 'Belgium',
    [CountryTypeDto.Pl]: 'Poland',
    [CountryTypeDto.Ro]: 'Romania',
    [CountryTypeDto.Sk]: 'Slovakia',
  },
  deleteConfirmation: 'Are you sure you want to delete this experience company?',
  dialog: {
    buttons: {
      cancel: 'Cancel',
      create: 'Create',
      save: 'Save',
    },
    createTitle: 'Add Experience Company',
    editTitle: 'Edit Experience Company',
    fields: {
      country: 'Country',
      name: 'Name',
      type: 'Type',
    },
    validation: {
      nameExists: 'A company with this name already exists',
      nameRequired: 'Company name is required.',
    },
  },
  filterByCountry: 'Filter by country',
  filterByType: 'Filter by type',
  noResults: 'No experience companies found.',
  searchPlaceholder: 'Search by name...',
  types: {
    [ExperienceCompanyTypeDto.Competitor]: 'Competitor',
    [ExperienceCompanyTypeDto.None]: 'None',
    [ExperienceCompanyTypeDto.Orange]: 'Orange',
    [ExperienceCompanyTypeDto.Partner]: 'Partner',
  },
};
